/* tslint:disable */
/* eslint-disable */
/**
 * ADMIN-SERVICE - REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.1.0-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MetaDataFromJSON, MetaDataToJSON, PageRequestFromJSON, PageRequestToJSON, TagListEntryFromJSON, TagListEntryToJSON, } from './';
export function PagedResponseOfTagListEntryFromJSON(json) {
    return PagedResponseOfTagListEntryFromJSONTyped(json, false);
}
export function PagedResponseOfTagListEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'hasNext': !exists(json, 'hasNext') ? undefined : json['hasNext'],
        'metaData': !exists(json, 'metaData') ? undefined : MetaDataFromJSON(json['metaData']),
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'size': !exists(json, 'size') ? undefined : json['size'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'nextPage': !exists(json, 'nextPage') ? undefined : PageRequestFromJSON(json['nextPage']),
        'hasPrevious': !exists(json, 'hasPrevious') ? undefined : json['hasPrevious'],
        'previousPage': !exists(json, 'previousPage') ? undefined : PageRequestFromJSON(json['previousPage']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'entries': !exists(json, 'entries') ? undefined : (json['entries'].map(TagListEntryFromJSON))
    };
}
export function PagedResponseOfTagListEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'hasNext': value.hasNext,
        'metaData': MetaDataToJSON(value.metaData),
        'numberOfElements': value.numberOfElements,
        'size': value.size,
        'page': value.page,
        'nextPage': PageRequestToJSON(value.nextPage),
        'hasPrevious': value.hasPrevious,
        'previousPage': PageRequestToJSON(value.previousPage),
        'totalElements': value.totalElements,
        'entries': value.entries === undefined ? undefined : (value.entries.map(TagListEntryToJSON))
    };
}
